// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// API Endpoints
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: `${API_BASE_URL}/auth/login`,
    LOGOUT: `${API_BASE_URL}/auth/logout`,
    FORGOT_PASSWORD: `${API_BASE_URL}/auth/forgot-password`,
    RESET_PASSWORD: `${API_BASE_URL}/auth/reset-password`,
    VERIFY_OTP: `${API_BASE_URL}/auth/verify-otp`,
    LOGIN_EMAIL_OTP: `${API_BASE_URL}/auth/login-email-otp`,
    VERIFY_EMAIL_OTP: `${API_BASE_URL}/auth/verify-email-otp`,
    LOGIN_MOBILE_OTP: `${API_BASE_URL}/auth/login-mobile-otp`,
    VERIFY_MOBILE_OTP: `${API_BASE_URL}/auth/verify-mobile-otp`,
    ADD_EMPLOYEE: `${API_BASE_URL}/auth/add-employee`
  },
  USER: {
    PROFILE: `${API_BASE_URL}/user/profile`,
    UPDATE_PROFILE: `${API_BASE_URL}/user/profile`,
    CHANGE_PASSWORD: `${API_BASE_URL}/user/change-password`
  },
  JOBS: {
    LIST: `${API_BASE_URL}/jobs`,
    CREATE: `${API_BASE_URL}/jobs`,
    GET: (id) => `${API_BASE_URL}/jobs/${id}`,
    UPDATE: (id) => `${API_BASE_URL}/jobs/${id}`,
    DELETE: (id) => `${API_BASE_URL}/jobs/${id}`,
    BULK_DELETE: `${API_BASE_URL}/jobs/bulk-delete`,
    PUBLISH: (id) => `${API_BASE_URL}/jobs/${id}/publish`,
    APPLICATIONS: (id) => `${API_BASE_URL}/jobs/${id}/applications`,
    PUBLIC: {
      LIST: `${API_BASE_URL}/jobs/public`,
      GET_JOB: `${API_BASE_URL}/jobs/public`,
      APPLY_JOB: `${API_BASE_URL}/jobs/public`
    }
  },
  HR: {
    EMPLOYEES: `${API_BASE_URL}/hr/employees`,
    EMPLOYEES_DROPDOWN: `${API_BASE_URL}/hr/employees/dropdown`,
    EMPLOYEES_DROPDOWN_SEARCH: `${API_BASE_URL}/dropdown-data/employees`,
    DEPARTMENTS: `${API_BASE_URL}/hr/departments`,
    ROLES: `${API_BASE_URL}/hr/roles`,
    MANAGERS: `${API_BASE_URL}/hr/managers`,
    POLICIES: `${API_BASE_URL}/hr/policies`,
    LEAVE_TYPES: `${API_BASE_URL}/hr/leave-types`,
  },
  LOCATIONS: {
    BASE: `${API_BASE_URL}/locations`,
    ACTIVE: `${API_BASE_URL}/locations/active`
  },
  CRM: {
    LEADS: `${API_BASE_URL}/crm/leads`,
    LEAD_STATISTICS: `${API_BASE_URL}/crm/leads/statistics`,
    OPPORTUNITIES: `${API_BASE_URL}/crm/opportunities`,
    OPPORTUNITIES_WITHOUT_QUOTATIONS: `${API_BASE_URL}/crm/opportunities/converted-without-quotations`, // Add new endpoint
    CUSTOMERS: `${API_BASE_URL}/crm/customers`,
    CUSTOMERS_360: `${API_BASE_URL}/crm/customers/360`,
    CAMPAIGNS: `${API_BASE_URL}/crm/campaigns`,
    QUOTATIONS: `${API_BASE_URL}/crm/quotations`,
    DOIS: `${API_BASE_URL}/crm/dois`,
    QUOTATION_DASHBOARD: `${API_BASE_URL}/crm/quotation-dashboard`,
    // QUOTE_ORDER_ANALYTICS: `${API_BASE_URL}/crm/analytics/quotes`,
    SALES_DASHBOARD: `${API_BASE_URL}/crm/analytics/sales-dashboard`,
    PRODUCTS: `${API_BASE_URL}/crm/products`,
    INVENTORY: `${API_BASE_URL}/crm/marg/inventory`,
    ORDERS: `${API_BASE_URL}/crm/orders`,
    TICKETS: `${API_BASE_URL}/crm/support/tickets`,
    ACTIVITIES: `${API_BASE_URL}/crm/activities`,
    ASSIGNMENT_RULES: `${API_BASE_URL}/crm/assignment-rules`,
    SHIPMENTS: {
      SYNC: `${API_BASE_URL}/shipments/sync`,
      LIST: `${API_BASE_URL}/shipments/list`,
      ANALYTICS: `${API_BASE_URL}/shipments/analytics`
    },
    SCORING_RULES: `${API_BASE_URL}/crm/scoring-rules`,
    QUALIFICATION_CRITERIA: `${API_BASE_URL}/crm/qualification-criteria`,
    LEAD_SCORES: `${API_BASE_URL}/crm/leads/scores`,
    RECALCULATE_SCORES: `${API_BASE_URL}/crm/leads/recalculate-scores`,
    // TASKS: `${API_BASE_URL}/crm/tasks`,
    // OPPORTUNITY_PIPELINE: `${API_BASE_URL}/crm/opportunity-pipeline`,
    TEAM_MANAGEMENT: {
      USERS: `${API_BASE_URL}/crm/team-management/users`,
    },
    TARGETS: `${API_BASE_URL}/crm/targets`,
    TELEPHONY: {
      LIVE_CALLS: `${API_BASE_URL}/crm/telephony/live-calls`,
    },
    LINKEDIN: {
      AUTHORIZE: `${API_BASE_URL}/crm/linkedin/authorize`,
      OAUTH_CALLBACK: `${API_BASE_URL}/crm/linkedin/oauth/callback`,
      SYNC: `${API_BASE_URL}/crm/linkedin/sync`,
      FORMS: `${API_BASE_URL}/crm/linkedin/forms`,
      STATUS: `${API_BASE_URL}/crm/linkedin/status`,
      DISCONNECT: `${API_BASE_URL}/crm/linkedin/disconnect`,
    },
    META: {
      AUTHORIZE: `${API_BASE_URL}/crm/meta/auth/facebook`,
      SYNC: `${API_BASE_URL}/crm/meta/sync-leads`,
      STATUS: `${API_BASE_URL}/crm/meta/status`,
      DISCONNECT: `${API_BASE_URL}/crm/meta/disconnect`,
    },
    CONFIG: {
      INDUSTRIES: `${API_BASE_URL}/config/industries`,
      INDUSTRIES_BULK_DELETE: `${API_BASE_URL}/config/industries/bulk-delete`,
      DECISION_MAKERS: `${API_BASE_URL}/config/decision-makers`,
      DECISION_MAKERS_BULK_DELETE: `${API_BASE_URL}/config/decision-makers/bulk-delete`,
      SOURCES: `${API_BASE_URL}/config/sources`,
      SOURCES_BULK_DELETE: `${API_BASE_URL}/config/sources/bulk-delete`,
      LEAD_SOURCES: `${API_BASE_URL}/config/lead-sources`,
      LEAD_SOURCES_BULK_DELETE: `${API_BASE_URL}/config/lead-sources/bulk-delete`,
      COURSE_TYPES: `${API_BASE_URL}/course-types`,
      COURSE_TYPES_BULK_DELETE: `${API_BASE_URL}/course-types/bulk-delete`,
      LEAD_DOCUMENT_TYPES: `${API_BASE_URL}/config/lead-document-types`,
      LEAD_CATEGORIES: `${API_BASE_URL}/config/lead-categories`,
      LEAD_STATUSES: `${API_BASE_URL}/config/lead-statuses`,
      LEAD_STATUSES_BULK_DELETE: `${API_BASE_URL}/config/lead-statuses/bulk-delete`,
      INTERVIEW_ROUNDS: `${API_BASE_URL}/config/interview-rounds`,
      REVENUE_TYPES: `${API_BASE_URL}/config/revenue-types`,
      LEAD_BUCKETS: `${API_BASE_URL}/config/lead-buckets`,
      BUSINESS_UNITS: `${API_BASE_URL}/config/business-units`,
      LAST_ACTIVE_CHANNELS: `${API_BASE_URL}/config/last-active-channels`,
      COMPANY_SIZES: `${API_BASE_URL}/config/company-sizes`,
      COMPANY_SIZES_BULK_DELETE: `${API_BASE_URL}/config/company-sizes/bulk-delete`
    },
  },
  USERS: {
    SUPPORT: `${API_BASE_URL}/users/support`,
    SUPPORT_TEAM: `${API_BASE_URL}/users/support-team`,
  },
  PUBLIC_QUOTE: `${API_BASE_URL}/public/quote`,
  EMPLOYEE_SELF_SERVICE: {
    PROFILE: `${API_BASE_URL}/ess/profile`,
    COMPLIANCE: `${API_BASE_URL}/ess/profile/compliance`,
    LEARNING_PATHS: `${API_BASE_URL}/ess/learning-paths`,
    ATTENDANCE: `${API_BASE_URL}/ess/attendance`,
    LEAVE: `${API_BASE_URL}/ess/leave`,
    PAYSLIPS: `${API_BASE_URL}/ess/payslips`,
    TRAINING: `${API_BASE_URL}/ess/training`,
    PERFORMANCE: `${API_BASE_URL}/ess/performance`,
    RESIGNATION: `${API_BASE_URL}/ess/resignation`,
    DOCUMENTS: `${API_BASE_URL}/ess/documents`,
    LEAVE_BALANCES: `${API_BASE_URL}/ess/leave-balances`,
    LEAVE_HISTORY: `${API_BASE_URL}/ess/leave-history`,
    QUIZ_DETAIL: (assignmentId) => `${API_BASE_URL}/ess/quizzes/${assignmentId}`,
    QUIZ_SUBMIT: (assignmentId) => `${API_BASE_URL}/ess/quizzes/${assignmentId}/submit`,
    REPORTING_TEAM: `${API_BASE_URL}/ess/reporting-team`,
  },
  ANALYTICS: {
    DASHBOARD_SUMMARY: `${API_BASE_URL}/analytics/dashboard-summary`,
    HR_DASHBOARD: `${API_BASE_URL}/analytics/hr-dashboard-summary`,
    CRM_REPORTS: `${API_BASE_URL}/analytics/crm-reports`,
    SALES_FUNNEL: `${API_BASE_URL}/analytics/sales-funnel`,
    PERFORMANCE_METRICS: `${API_BASE_URL}/analytics/performance-metrics`,
  },
  RECRUITMENT: {
    JOB_POSTS: `${API_BASE_URL}/recruitment/job-posts`,
    CANDIDATES: `${API_BASE_URL}/recruitment/candidates`,
    INTERVIEWS: `${API_BASE_URL}/recruitment/interviews`,
    OFFERS: `${API_BASE_URL}/recruitment/offers`,
    CANDIDATE_PIPELINE: `${API_BASE_URL}/recruitment/candidate-pipeline`,
    ANALYTICS: `${API_BASE_URL}/recruitment/analytics`,
  },
  OFFER_RESPONSE: {
    RESPONSE_PAGE: (id, action) => `${API_BASE_URL}/offer/${id}/response?action=${action}`,
    UPLOAD_DOCUMENTS: (id) => `${API_BASE_URL}/offer/${id}/upload-documents`
  },
  DOCUMENT_VERIFICATION: {
    DOCUMENTS: `${API_BASE_URL}/document-verification/documents`,
    VERIFY_DOCUMENT: (id) =>
      `${API_BASE_URL}/document-verification/documents/${id}/verify`,
    DOWNLOAD_DOCUMENT: (id) =>
      `${API_BASE_URL}/document-verification/documents/${id}/download`,
    STATISTICS: `${API_BASE_URL}/document-verification/statistics`,
  },
  JOINING_KIT: {
    LIST: `${API_BASE_URL}/joining-kit`,
    CREATE: `${API_BASE_URL}/joining-kit`,
    GET: (id) => `${API_BASE_URL}/joining-kit/${id}`,
    UPDATE: (id) => `${API_BASE_URL}/joining-kit/${id}`,
    DELETE: (id) => `${API_BASE_URL}/joining-kit/${id}`,
    SUBMIT: (id) => `${API_BASE_URL}/joining-kit/${id}/submit`,
  },
  BACKGROUND_VERIFICATION: {
    LIST: `${API_BASE_URL}/background-verification`,
    CREATE: `${API_BASE_URL}/background-verification`,
    GET: (id) => `${API_BASE_URL}/background-verification/${id}`,
    UPDATE: (id) => `${API_BASE_URL}/background-verification/${id}`,
    DELETE: (id) => `${API_BASE_URL}/background-verification/${id}`,
    VENDOR_UPDATE: (id) =>
      `${API_BASE_URL}/background-verification/${id}/vendor-update`,
    HR_DECISION: (id) =>
      `${API_BASE_URL}/background-verification/${id}/hr-decision`,
  },
  ORIENTATION: {
    LIST: `${API_BASE_URL}/orientation`,
    CREATE: `${API_BASE_URL}/orientation`,
    GET: (id) => `${API_BASE_URL}/orientation/${id}`,
    UPDATE: (id) => `${API_BASE_URL}/orientation/${id}`,
    DELETE: (id) => `${API_BASE_URL}/orientation/${id}`,
    INVITES: (id) => `${API_BASE_URL}/orientation/${id}/invites`,
    CLONE: (id) => `${API_BASE_URL}/orientation/${id}/clone`,
    ATTENDEES: (id) => `${API_BASE_URL}/orientation/${id}/attendees`,
    EXPORT: `${API_BASE_URL}/orientation/export`,
  },
  HR_BACKOFFICE: {
    DASHBOARD_STATS: `${API_BASE_URL}/hr-backoffice/dashboard-stats`,
    RECENT_ACTIVITIES: `${API_BASE_URL}/hr-backoffice/recent-activities`,
    PENDING_TASKS: `${API_BASE_URL}/hr-backoffice/pending-tasks`,
    QUICK_STATS: `${API_BASE_URL}/hr-backoffice/quick-stats`,
  },
  COMMUNICATION_LOGS: {
    LIST: `${API_BASE_URL}/communication-logs`,
    CREATE: `${API_BASE_URL}/communication-logs`,
    GET: (id) => `${API_BASE_URL}/communication-logs/${id}`,
    UPDATE: (id) => `${API_BASE_URL}/communication-logs/${id}`,
    DELETE: (id) => `${API_BASE_URL}/communication-logs/${id}`,
    REPLY: (id) => `${API_BASE_URL}/communication-logs/${id}/reply`,
    FORWARD: (id) => `${API_BASE_URL}/communication-logs/${id}/forward`,
    EXPORT: `${API_BASE_URL}/communication-logs/export`,
    STATS: `${API_BASE_URL}/communication-logs/stats`,
  },
  SYSTEM: {
    USERS: `${API_BASE_URL}/system/users`,
    ROLES: `${API_BASE_URL}/system/roles`,
    AUDIT_LOGS: `${API_BASE_URL}/system/audit-logs`,
    SETTINGS: `${API_BASE_URL}/system/settings`
  },
  // TENDER: {
  //   LIST: `${API_BASE_URL}/crm/tenders`,
  //   CREATE: `${API_BASE_URL}/crm/tenders`,
  //   GET: (id) => `${API_BASE_URL}/crm/tenders/${id}`,
  //   UPDATE: (id) => `${API_BASE_URL}/crm/tenders/${id}`,
  //   DELETE: (id) => `${API_BASE_URL}/crm/tenders/${id}`,
  // },
  TRAINING: {
    COURSES: `${API_BASE_URL}/training/courses`,
    SESSIONS: `${API_BASE_URL}/training/sessions`,
    ASSIGNMENTS: `${API_BASE_URL}/training-assignments`,
    CERTIFICATES: `${API_BASE_URL}/training/certificates`,
    ANALYTICS: `${API_BASE_URL}/training/analytics`,
    REPORTS: `${API_BASE_URL}/training/reports`,
    PROGRESS: `${API_BASE_URL}/training/progress`,
    MODULES: `${API_BASE_URL}/training-modules`,
    QUIZZES: `${API_BASE_URL}/training-quizzes`,
    LEARNING_PATHS: `${API_BASE_URL}/training-learning-paths`,
    ATTENDANCE: `${API_BASE_URL}/training-attendance`,
    FEEDBACK: `${API_BASE_URL}/training-feedback`,
    COMPLIANCE: `${API_BASE_URL}/training-compliance`,
    SETTINGS: `${API_BASE_URL}/training-settings`,
    COURSE_STRUCTURE: (courseId) => `${API_BASE_URL}/training-structure/course-structure/${courseId}`,
    COURSE_MODULES: (courseId) => `${API_BASE_URL}/training-structure/course-structure/${courseId}/modules`,
    COURSE_MODULE: (courseId, moduleId) => `${API_BASE_URL}/training-structure/course-structure/${courseId}/modules/${moduleId}`,
    COURSE_LESSONS: (courseId, moduleId) => `${API_BASE_URL}/training-structure/course-structure/${courseId}/modules/${moduleId}/lessons`,
    COURSE_LESSON: (courseId, moduleId, lessonId) => `${API_BASE_URL}/training-structure/course-structure/${courseId}/modules/${moduleId}/lessons/${lessonId}`
  },
  UPLOAD: {
    CLOUDINARY: `${API_BASE_URL}/upload/cloudinary`
  }
};

// HTTP Methods
export const HTTP_METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
  PATCH: "PATCH",
};

// Default headers
export const DEFAULT_HEADERS = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

// Request timeout (in milliseconds)
export const REQUEST_TIMEOUT = 30000;

// Storage keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: "auth_token",
  USER_DATA: "user_data",
  REMEMBER_ME: "remember_me",
};

// Error messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error. Please check your connection.',
  TIMEOUT_ERROR: 'Request timeout. Please try again.',
  UNAUTHORIZED: 'Unauthorized access. Please login again.',
  FORBIDDEN: 'Access forbidden. You don\'t have permission.',
  NOT_FOUND: 'Resource not found.',
  SERVER_ERROR: 'Server error. Please try again later.',
  VALIDATION_ERROR: 'Validation error. Please check your input.',
  BAD_REQUEST: 'Bad request. Please check your input.',
  UNKNOWN_ERROR: 'An unknown error occurred.'
};

// Success messages
export const SUCCESS_MESSAGES = {
  LOGIN_SUCCESS: "Login successful!",
  LOGOUT_SUCCESS: "Logout successful!",
  PASSWORD_RESET_SUCCESS: "Password reset successful!",
  PROFILE_UPDATE_SUCCESS: "Profile updated successfully!",
  DATA_SAVED_SUCCESS: "Data saved successfully!",
  OPERATION_SUCCESS: "Operation completed successfully!",
};

// Export individual constants
export { API_BASE_URL };

export default {
  API_BASE_URL,
  HTTP_METHODS,
  DEFAULT_HEADERS,
  REQUEST_TIMEOUT,
  STORAGE_KEYS,
  ERROR_MESSAGES,
  SUCCESS_MESSAGES,
};
